var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AdminUser',{attrs:{"privileges":_vm.privileges,"changeTitle":_vm.changeTitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }